module.exports = __webpack_public_path__ + "img/upload-files-blue.f818b778.svg";